<script setup>
import { XMarkIcon } from "@heroicons/vue/24/solid";
import { useI18n } from "vue-i18n";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  align: {
    type: String,
    default: "left",
    required: false,
  },
});

const { t } = useI18n();
</script>

<template>
  <div
    class="flex h-full items-center whitespace-nowrap p-4"
    :class="{
      'justify-start': props.align === 'left',
      'justify-center text-center': props.align === 'center',
      'justify-end': props.align === 'right',
    }"
  >
    <template v-if="props.data !== null && props.data.status !== null">
      <span
        v-if="props.data.status === 'open'"
      >
        {{ t("all.label.open") }}
      </span>

      <span
        v-if="props.data.status === 'closed'"
        class="rounded bg-green-500 px-3 py-2 text-xs font-bold text-white"
      >
        {{ t("all.label.closed") }}
      </span>

      <span
        v-if="props.data.status === 'to_process'"
      >
        {{ t("all.label.toProcess") }}
      </span>

      <span
        v-if="props.data.status === 'processed'"
        class="rounded bg-green-500 px-3 py-2 text-xs font-bold text-white"
      >
        {{ t("label.processed") }}
      </span>
    </template>

    <template v-else>
      <XMarkIcon class="size-5 text-red-500" />
    </template>
  </div>
</template>
